<template>
    <f7-page
        :page-content="false"
        name="Onboarding 4"
        navbar-hidden
        no-navbar
        class="onboardingBg"
    >
        <div class="bg-wrapper">
            <div class="parallax-bg" />
            <div class="parallax-bg-2" />
            <div style="max-width: 400px; margin: 160px auto 0">
                <h2>
                    Thanks
                </h2>
                <f7-block>
                    Wait a moment while we customize your journey.
                </f7-block>
            </div>
            <f7-block class="absBottom">
                <div class="coral">
                    <div :class="`coral_growth ${seconds < 7 ? 'growing' : ''}`" />
                </div>

                <f7-button
                    :color="'grayer'"
                    :href="'#'"
                    style="opacity: 0"
                    fill
                    round
                >Ready in {{ seconds }}... </f7-button>
            </f7-block>
        </div>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'user'],
    data () {
        return {
            seconds: 7,
            variant: 0,
        }
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () {
        this.variant = parseFloat(window.localStore.getItem(`experiment-014_goals`));
        let interval = setInterval(() => {
            this.seconds--;
            if (this.seconds === 0) {
                clearInterval(interval);
                if (!localStore.getItem('freeFromPartner')) {
                    // not needed to redirect as happens already in function
                    let url = (this.user.isSubscribed ? ([1, 3].indexOf(this.variant) > -1 ? '/onboarding/goals' : '/home') : '/subscribeStart?goToHome=1');
                    f7.views['main'].router.navigate(url, { reload: false, animatePages: true, transition: 'f7-fade' });
                }
                localStore.removeItem('freeFromPartner');
            }
        }, 1000);
    },
    beforeDestroy: function () {

    },
    mounted: function () { },
    methods: {

    }
};
</script>

<style lang="less" scoped>
.theme-dark {
    h2 {
        color: white;
    }
}
.bg-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.parallax-bg {
    position: absolute;
    left: calc(~'-1600px' - 50vw);
    top: 0;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_top.png) top right no-repeat;
    background-size: 3670.5px 171.5px;
    height: 171.5px;
    width: 3670.5px;
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-4200px' - 50vw);
    bottom: 0px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom.png) bottom left
        no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
.coral {
    background: url(../../img/1.2.0/coral.png) bottom right no-repeat;
    background-size: 221px 278px;
    height: 278px;
    width: 221px;
    margin: 0 auto -10px;
    position: relative;
    .coral_growth {
        position: absolute;
        bottom: 22px;
        left: -2px;
        background: url(../../img/1.2.0/coral_growth.png) bottom right no-repeat;
        background-size: 205px 212.5px;
        height: 0;
        border-radius: 30%;
        width: 233px;
        opacity: 0.3;
        transition: all 5s ease-out;
        &.growing {
            opacity: 1;
            height: 212.5px;
            width: 233px;
        }
    }
}

.absBottom {
    overflow: visible;
    // border-top: 1px solid #efefef;
    text-align: center;
    position: absolute;
    z-index: 100000;
    bottom: 50px;
    width: 100%;
    margin: 0;
}
</style>
